import { useIdle } from '@vueuse/core';
import { watch } from 'vue';
import { pauseOidcRefresh, resumeOidcRefresh } from '@/composables/useOidcTokenRefresh';
import { pauseSmCookieRefresh, resumeSmCookieRefresh } from '@/composables/useSmCookieRefresh';
import { isOidcSession } from '@/utils/helpers';

const IDLE_THRESHOLD_MS = 2 * 60 * 1000;

export const useOidcIdleGuard = () => {
  const { idle } = useIdle(IDLE_THRESHOLD_MS);

  watch(idle, async (isIdle) => {
    if (!isOidcSession()) return;

    if (isIdle) {
      pauseOidcRefresh();
      pauseSmCookieRefresh();
    } else {
      const sessionAlive = await resumeSmCookieRefresh();
      if (sessionAlive) {
        resumeOidcRefresh();
      }
    }
  });
};
